import Grid2 from "@mui/material/Grid2";
import React from "react";
import { useFormContext } from "react-hook-form";
import FormTextField from "../../Common/FormTextField";
import { getFieldPath } from "../../Common/SchemaUtils";

const AddressFormFields: React.FC<{
  extractionId: string;
  extractionPath?: string;
  label?: string;
}> = ({ extractionId, extractionPath }) => {
  const { control } = useFormContext();
  return (
    <Grid2
      container
      spacing={1}
      key={getFieldPath([extractionId, extractionPath])}
    >
      <Grid2 size={4}>
        <FormTextField
          size="small"
          name={`extraction.${getFieldPath([extractionId, "value", extractionPath])}.number`}
          control={control}
          label="Numéro"
        />
      </Grid2>
      <Grid2 size={8}>
        <FormTextField
          size="small"
          name={`extraction.${getFieldPath([extractionId, "value", extractionPath])}.way`}
          control={control}
          label="Rue"
        />
      </Grid2>
      <Grid2 size={6}>
        <FormTextField
          size="small"
          name={`extraction.${getFieldPath([extractionId, "value", extractionPath])}.postal_code`}
          control={control}
          label="Code postal"
        />
      </Grid2>
      <Grid2 size={6}>
        <FormTextField
          size="small"
          name={`extraction.${getFieldPath([extractionId, "value", extractionPath])}.city`}
          control={control}
          label="Ville"
        />
      </Grid2>
      <Grid2 size={12}>
        <FormTextField
          size="small"
          name={`extraction.${getFieldPath([extractionId, "value", extractionPath])}.country`}
          control={control}
          label="Pays"
          className="grow"
        />
      </Grid2>
    </Grid2>
  );
};

export default AddressFormFields;
